import Vue from "vue";
import VueI18n from "vue-i18n";

Vue.use(VueI18n);

function loadLocaleMessages() {
  const locales = require.context(
    "./locales",
    true,
    /[A-Za-z0-9-_,\s]+\.json$/i
  );
  const messages = {};
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      messages[locale] = locales(key);
    }
  });
  return messages;
}

var lang = navigator.language.slice(0,2);

let locale = window.location.pathname.match('^/([a-z][a-z])');

if (locale) {
  lang = locale[1];
} else {
  if (lang != 'nl' && lang != 'en') {
    lang = 'en';
  }
}

export default new VueI18n({
  locale: (lang !== null ? lang : process.env.VUE_APP_I18N_FALLBACK_LOCALE) || "en",
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || "en",
  messages: loadLocaleMessages()
});